import { IonChip, IonIcon, IonLabel } from '@ionic/react';
import { useFormikContext } from 'formik';
import { checkmarkCircleOutline, ellipseOutline } from 'ionicons/icons';
import { ReactElement } from 'react';
import { IonItem } from '../../../../../../components/ionic/IonItem';
import { i18nKeyType } from '../../../../../../i18n';
import { getLocalizedText } from '../../../../../../i18n/i18n.utils';
import { useFlowItemFormContext } from '../../../../shared/component/flow-item/edit/flow-item-form.context';
import { TeachOptionsBaseProps } from '../../../../shared/component/teach/teach.types';
import { PickerOption } from '../../../../shared/component/widget/widget.types';
import {
  FlowItemForm,
  FlowItemParameterMetadata,
} from '../../../../shared/model/flow.types';

export interface TeachItemPickerOptionsProps extends TeachOptionsBaseProps {
  parameterMetadata: FlowItemParameterMetadata;
  children?: ReactElement | React.FC<{ value: unknown }>;
}

const TeachItemPickerOptions = (
  props: TeachItemPickerOptionsProps
): ReactElement => {
  const { onChange, onAdd, parameterMetadata, children } = props;

  const { setParameterValue } = useFlowItemFormContext();
  const { values } = useFormikContext<FlowItemForm>();

  const options: PickerOption[] = parameterMetadata?.ui?.widgetOptions ?? [];

  return (
    <>
      {options.map((o, index) => {
        const isSelected =
          `${values.parameters[parameterMetadata.ref]?.value}` === `${o.value}`;
        const icon = isSelected ? checkmarkCircleOutline : ellipseOutline;
        const itemClassList = ['transparent-background'];
        if (!isSelected) {
          itemClassList.push('dim');
        } else {
          itemClassList.push('selected');
        }
        return (
          <IonItem
            key={index}
            className={itemClassList.join(' ')}
            lines="none"
            detail={false}
            color={isSelected ? 'primary' : undefined}
            onClick={() => {
              setParameterValue(parameterMetadata.ref, o.value);
              if (onChange) {
                onChange();
              }
            }}
            button
          >
            <IonIcon slot="start" icon={icon} />
            <IonLabel>{getLocalizedText(o.label as i18nKeyType)}</IonLabel>
            {isSelected && (
              <IonChip
                className="add-button"
                slot="end"
                onClick={(e) => {
                  e.preventDefault();
                  if (onAdd) {
                    onAdd();
                  }
                }}
              >
                {getLocalizedText('common:add')}
              </IonChip>
            )}
          </IonItem>
        );
      })}
      {typeof children === 'function'
        ? children({ value: values.parameters[parameterMetadata.ref]?.value })
        : children}
    </>
  );
};

export { TeachItemPickerOptions };
